import { Injectable } from '@angular/core';

import { HttpClient } from '@angular/common/http';

@Injectable()
export class ConfigService {

  constructor(private http: HttpClient) { }

  appVersion() {
    return this.http.get(`/api/v1/config/appversion`);
  }

  hubspotConfig() {
    return this.http.get(`/api/v1/config/hubspot`);
  }

  eloquaConfig() {
    return this.http.get(`/api/v1/config/eloqua`);
  }

  actOnConfig() {
    return this.http.get(`/api/v1/config/acton`);
  }

  gmailConfig() {
    return this.http.get(`/api/v1/config/gmail`);
  }

  o365Config() {
    return this.http.get(`/api/v1/config/o365`);
  }

  driftAppUrl() {
    return this.http.get(`/api/v1/config/driftAppUrl`)
  }
}



// WEBPACK FOOTER //
// ./client/app/services/config.service.ts